import React from "react";
import "./MenuFlows.css";
import { Button } from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

/**
 * A dropdown menu component for the header that displays a list of flows. It includes functionality to open and close the menu.
 * The menu is triggered by a button with a dropdown icon and is styled using Material-UI.
 * 
 * @component
 * @example
 * import MenuFlows from "../../Components/MenuFlows/MenuFlows";
 * <MenuFlows menuList={menuApi} />
 * @param {Array} menuList - A list of menu items (flows) to display in the dropdown. This data typically comes from an API.
 * @returns {React.Fragment} The rendered dropdown menu component.
 */
function MenuFlows({ menuList }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  /**
   * Handles the click event to open or close the dropdown menu.
   * 
   * @param {Event} event - The click event.
   */
  const onClickMenuHandler = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  // /**
  //  * Handles closing the dropdown menu.
  //  */
  // const onCloseMenuHandler = () => {
  //   setAnchorEl(null);
  // };

  return (
    <>
      <Button
        id="menu-flow-button"
        aria-controls={open ? 'flow-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="text"
        disableElevation
        onClick={onClickMenuHandler}
        endIcon={<KeyboardArrowDownIcon />}
      >
        Flows
      </Button>
      {/* <Menu        
        id="flow-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={onCloseMenuHandler}
        MenuListProps={{
          "aria-labelledby": "flow-menu",
        }}
        sx={{ marginTop: "10px"}}
      >
        {displayOptions()}
      </Menu> */}
    </>
  );
}

export default MenuFlows;
